import { useRouter } from 'next/router';

import Preset from '@/domain/Preset/Preset';
import { logoutAuthSession } from '@/features/auth/api';

const useLogout = () => {
	const { push } = useRouter();

	const onLogout = async () => {
		await Preset.deleteAllPreset();
		const result = await logoutAuthSession().catch((error) => {
			console.error(error);

			return null;
		});

		if (typeof window !== 'undefined' && result?.externalLogoutUrl) {
			window.location.assign(result.externalLogoutUrl);
			return;
		}

		await push('/login');
	};

	return {
		logOut: onLogout,
	};
};

export default useLogout;
